/**
 * Created by asiulik on 15.05.2017.
 */

define(function(){

    return {

        finderSelector: '.m__finder:not(.m__finder--overlay)',
        finderInOvelaySelector: '.m__finder.m__finder--overlay',
        finderInitedClass: "m__finder--inited",
        finderMapSelector: '.finder__map',
        finderMarkersSelector: ".finder__markers",
        finderMarkersItems: ".finder__markers__item",
        finderContentSelector: ".finder__markers",
        finderContentItem: ".finder__markers__item",
        finderContentItemActiveClass: "finder__content__item--active",
        finderContentBoxDisplay: "finder__content--display",
        finderContentChangeDuration: 400,
        finderMapPreloaderSelector: '.finder__loader',
        finderToggleListMobileButtonSelector: "#toggleMobileListButton"
    }

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finderConst.js